/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';

const routeSlideStyle: ouiStyle.InStyle = {
  overflowX: 'hidden',
  flex: 'one',
  widthLines: 'full',
};

export const RouteContainer = (props: React.PropsWithChildren<{
  marginTop?: string,
}>) => {
  const {
    marginTop,
    children,
  } = props;
  const routeSlideCss = React.useMemo(
    () => ouiStyle.mediaQuery({
      ...ouiStyle.makeCss(routeSlideStyle),
      marginTop,
      '-ms-overflow-style': 'none',
      scrollbarWidth: 'none',
      '::-webkit-scrollbar': {
        display: 'none',
      },
    }),
    [marginTop],
  );
  return (
    <div
      css={routeSlideCss}
    >
      {children}
    </div>
  );
};
